var _style, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGerman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 72.55 70.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-german-flag1{fill:none;stroke:#36546b;stroke-miterlimit:10;stroke-width:2px;}.cls-german-flag2{clip-path:url(#clip-path);}.cls-german-flag3{fill:#ffca05;}.cls-german-flag3,.cls-german-flag4,.cls-german-flag5{fill-rule:evenodd;}.cls-german-flag4{fill:#3d3d3d;}.cls-german-flag5{fill:#fa4949;}")), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(2.5 1.64)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-german-flag1",
    cx: 34,
    cy: 34,
    r: 31.04
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-german-flag2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-german-flag3",
    points: "72.55 47.13 72.55 70.65 0 70.65 0 47.13 72.55 47.13 72.55 47.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-german-flag4",
    points: "72.55 0 72.55 23.62 0 23.62 0 0 72.55 0 72.55 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-german-flag5",
    points: "72.55 23.63 72.55 47.13 0 47.13 0 23.63 72.55 23.63 72.55 23.63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerman);
export default __webpack_public_path__ + "static/media/German.79ecc7ed.svg";
export { ForwardRef as ReactComponent };